import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { BuildService } from '../build.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { GfTitleService } from '../../../core/services/core.title.service';
import * as _ from 'lodash';

@Component({
    selector: 'buildBrowse',
    template: require('./browse.html')
})
export class BuildBrowseComponent implements OnInit {
    expandDescription: any;

    @Input() project: any;
    @Input() projectMenu: any;

    sortFields = {};
    sort = {};
    paging: any = {};
    filters = {};

    buildItems = null;
    recentBuilds = null;
    section = false;
    recentOpen = false;
    stateService: StateService;

    constructor(
        stateService: StateService,
        private buildService: BuildService,
        private window: Window,
        private translateService: GfTranslateService,
        private titleService: GfTitleService,
    ) {
        this.stateService = stateService;
    }


    ngOnInit() {
        this.sortFields = {
            id: this.translateService.translate('Build Date'),
            wasSuccessful: this.translateService.translate('Success'),
            buildNumber: this.translateService.translate('Build Number'),
            description: this.translateService.translate('Description'),
            changelog: this.translateService.translate('Changelog')
        };
        this.sort = {
            sort_field: _.get(this.stateService.params, 'sort_field', 'id'),
            sort_dir: _.get(this.stateService.params, 'sort_dir', 'desc')
        };

        this.paging = {
            page_num: _.get(this.stateService.params, 'page_num', 1),
            page_size: _.get(this.stateService.params, 'page_size', 20)
        };

        this.filters = {
            main_fields: this.setFilterValues(this.getBaseFilters(), this.stateService.params)
        };

        this.titleService.setTitle(this.project.name, 'Builds');
        this.refresh();
        this.getRecent();
    };

    refresh() {
        this.buildItems = false;
        const fetchArgs = this.getFetchParams();
        this.buildService.fetch(this.project.unixName, fetchArgs)
            .then((response) => {
                this.buildItems = _.get(response, 'items', []);
            }, (response) => {
                console.log("Build fetch failed", response);
                this.buildItems = [];
            });
    };

    toggleRecent() {
        this.recentOpen = !this.recentOpen;
        if (!this.recentBuilds) {
            this.getRecent();
        }
    };

    getRecent() {
        this.recentBuilds = null;
        this.buildService.fetch(this.project.unixName).then((response) => {
            this.recentBuilds = _.sortBy(
                _.get(response, 'items', []),
                ['id']
            )
                .reverse()
                .slice(0, 10);
        }, (response) => {
            console.log("get Recent builds fail", response);
            this.recentBuilds = [];
        });
    };

    updatePaging(params) {
        this.paging = params;
        this.applyFilters();
    };

    getFetchParams() {
        return Object.assign(
            { unixName: this.stateService.params?.unixName },
            this.sort,
            this.paging,
            this.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            )
        );
    }

    applyFilters() {
        const params = this.getFetchParams();
        this.stateService.go('.', params, { notify: true, inherit: false })
            .then(() => { this.refresh(); }, () => { });
    }

    getFilterValues(filters) {
        return _.reduce(
            filters,
            function (carry, f) {
                var key = f.alias;
                var val = _.get(f, 'value.id', _.get(f, 'value', ''));

                if (val != '') {
                    carry[key] = val;
                }

                return carry;
            },
            {}
        );
    }

    getBaseFilters() {
        return [
            { id: "job", alias: "job", fieldName: this.translateService.translate("Job Name"), value: "", fieldType: 4, isExtraField: false },
            { id: "jobDescription", alias: "jobDescription", fieldName: this.translateService.translate("Job Description"), value: "", fieldType: 4, isExtraField: false },
            { id: "description", alias: "description", fieldName: this.translateService.translate("Build Description"), value: "", fieldType: 4, isExtraField: false },
            { id: "changelog", alias: "changelog", fieldName: this.translateService.translate("Changelog"), value: "", fieldType: 4, isExtraField: false },
            { id: "buildNumber", alias: "buildNumber", fieldName: this.translateService.translate("Build Number"), value: "", fieldType: 10, isExtraField: false },
            { id: "wasSuccessful", alias: "wasSuccessful", fieldName: this.translateService.translate("Build Result"), value: { id: '', label: this.translateService.translate("Any") }, fieldType: 1, isExtraField: false, fieldElements: [{ id: '', label: this.translateService.translate("Any") }, { id: '1', label: this.translateService.translate("Successful") }, { id: '0', label: this.translateService.translate("Failure") }] }
        ];
    }

    setFilterValues(filters, params) {
        return _.map(
            filters,
            function (f) {
                var value = _.get(params, f.alias, '');
                var valObject = _.find(
                    _.get(f, 'fieldElements', []),
                    function (item) { return item.id == value; }
                );
                _.set(f, 'value', valObject ? valObject : value);
                return f;
            }
        );
    }

    onApplyFilters($event) {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters() {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: this.getBaseFilters()
        };
        this.applyFilters();
    };

    setSort(params) {
        this.sort = {
            sort_field: _.get(params, 'key', 'id'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };
}

